import { DeleteEntityName } from './useDeleteRun.constants';
import { INSTRUCTION_POLLING_LABELS } from './useInstructionPolling.labels';

export const POLL_INTERVAL_MS = 2500;
export const MAX_POLL_ATTEMPTS = 120;

export const INSTRUCTION_STATUS = {
	IN_PROGRESS: 'IN_PROGRESS',
	DONE: 'DONE',
	FAILED: 'FAILED'
} as const;

export const SUCCESS_MESSAGE_BY_ENTITY: Record<DeleteEntityName, string> = {
	session: INSTRUCTION_POLLING_LABELS.SUCCESS_SESSION,
	test: INSTRUCTION_POLLING_LABELS.SUCCESS_TEST
};
